import data from "../../TechStack.json";
import "./TechStack.css";

const TechStack = () => {
  return (
    // <div className=" tech-stack-wrapper">
    <div className="innerWidth tech-stack-container">
      <div
        className="
       py-1"
      >
        <div class="center-container">
          <div class="technology-badge">Technology Stacks</div>
        </div>
      </div>
      <div className="flexCenter tech-stac tech-image-container">
        <div className="row">
          {data.TechStack_1.map((response) => (
            <div
              key={response.stackName}
              className="col-4 col-md-4 col-lg-2 my-4 flexColCenter"
            >
              <img
                key={response.stackName}
                className="pb-3 tech-stack-image"
                src={response.imageUrl}
                alt={response.stackName}
              />
              <div
                className=" card-text"
                style={{
                  width: "10rem",
                  textAlign: "center",
                  fontSize: "1rem",
                  fontWeight: "400",
                  lineHeight: "19px",
                  fontFamily: "Montserrat",
                }}
              >
                <div className="card-body">
                  <p className="card-text">{response.stackName}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
    // </div>
  );
};

export default TechStack;
